import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {Button, Link, Stack} from '@customink/pigment-react';
import {useSelector} from 'react-redux';
import {
  isDragNDropAnywhereEnabled as isDragNDropAnywhereEnabledSelector,
  isUploadFileSizeEnabled as isUploadFileSizeEnabledSelector
} from '~/selectors/ConfigSelectors';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function UploadFileUnsupportedError(props) {
  const {dismiss} = props;
  const isDragNDropAnywhereEnabled = useSelector(
    isDragNDropAnywhereEnabledSelector
  );
  const isUploadFileSizeEnabled = useSelector(isUploadFileSizeEnabledSelector);
  const maxFileSize = isUploadFileSizeEnabled ? '20 MB' : '5 MB';

  useEffect(() => {
    window.setChatElements?.(); // LP init
  }, []);
  return (
    <Notification
      {...props}
      title={
        <span>
          <span>{isDragNDropAnywhereEnabled ? '' : <>Oops!&nbsp;</>}</span>
          <span>Your file is an unsupported file type.</span>
        </span>
      }>
      <p>
        Accepted file types (max size {maxFileSize}):{' '}
        {isDragNDropAnywhereEnabled
          ? 'AI, AVIF, BMP, EPS, GIF, HEIC, JPEG, JPG, PDF, PNG, PSD, TIF, TIFF, WEBP'
          : ' .JPG .JPEG .PNG .GIF .BMP .PDF .AI .PSD .EPS .WEBP .HEIC .AVIF .TIF .TIFF'}
      </p>
      <p>
        Have a different type of file?{' '}
        {isDragNDropAnywhereEnabled ? (
          <>
            <Link id="LP_upload-file-type">Chat now</Link> or email{' '}
            <Link href="mailto:service@customink.com">
              service@customink.com
            </Link>{' '}
            and we'll have it ready for you to use within a few hours!
          </>
        ) : (
          <>
            <span>
              <Link href="#/help" onClick={dismiss}>
                Email it to us
              </Link>
            </span>{' '}
            and we'll have it ready for you to use within a few hours!
          </>
        )}
      </p>
      <Stack className="notification-stack">
        <Button
          size="large"
          variant="secondary"
          className="notification-cta"
          onClick={dismiss}>
          Close
        </Button>
      </Stack>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func
};

UploadFileUnsupportedError.propTypes = propTypes;

UploadFileUnsupportedError.displayName = 'UploadFileUnsupportedError';
